import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import PolicyCard from "../../components/Common/PolicyCard";
import NodataAvailable from "../../components/Common/NodataAvailable";
import ContentLoader from "../ContentLoader";
import i18n from "i18next";

const Privacy = () => {
  const [policy, setPolicy] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentLang = i18n.language;

  useEffect(() => {
    axios.get(`/api/policy`).then((res) => {
      if (res.status === 200) {
        setPolicy(res.data.data);
        setLoading(false);
      }
    });
  }, [currentLang]);
  return (
    <>
      {loading ? (
        <ContentLoader />
      ) : (
        <>
          {policy.length === 0 ? (
            <NodataAvailable />
          ) : (
            <PolicyCard title={"Privacy Policy"} description={policy} currentLang={currentLang} />
          )}
        </>
      )}
    </>
  );
};

export default Privacy;
